import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
} from "@/components/ui/card";

export default function Installation() {
    return (
        <div className="space-y-6">
            <h2 className="text-3xl font-bold tracking-tight">Installation</h2>
            <div className="grid gap-6">
                <Card>
                    <CardHeader>
                        <CardTitle>1. Install the Optifi App</CardTitle>
                        <CardDescription>
                            Getting started with Optifi
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            When you signed up for Optifi, we will have sent you
                            a custom app install link for Shopify. Click this
                            link to begin the installation process for your
                            store.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">
                                Note: You must be a Shopify store owner or have
                                admin access to install the app.
                            </p>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>2. Connect Your Store</CardTitle>
                        <CardDescription>
                            Linking your Shopify store
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Once the app has been installed, navigate to the
                            integrations page in the Optifi dashboard. Enter
                            your Shopify store domain (in the form
                            yourstorename.myshopify.com) to link your store. We
                            will usually have provided the correct domain in the
                            email you received when you signed up.
                        </p>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>3. Enable Optifi pixel</CardTitle>
                        <CardDescription>
                            Enable the Optifi pixel to start tracking page
                            visits.
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            Once the app has been installed, click the "Enable
                            Optifi pixel" button in the integrations page in
                            Optifi. This will navigate to the Shopify theme
                            editor, where you can enable the Optifi pixel by
                            clicking the slider switch in the theme editor.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">
                                Make sure to click the "Save" button in the
                                theme editor to save the changes.
                            </p>
                        </div>
                    </CardContent>
                </Card>

                <Card>
                    <CardHeader>
                        <CardTitle>4. Verify Installation</CardTitle>
                        <CardDescription>
                            Ensuring everything is set up correctly
                        </CardDescription>
                    </CardHeader>
                    <CardContent className="space-y-4">
                        <p className="text-sm text-muted-foreground">
                            After installation, verify that your store is
                            properly connected by checking the products page in
                            Optifi. You should see your products listed.
                        </p>
                        <div className="rounded-md bg-muted p-4">
                            <p className="text-sm">
                                If you encounter any issues, try clicking the
                                "Sync" button on the products page. If you still
                                encounter issues, please contact us.
                            </p>
                        </div>
                    </CardContent>
                </Card>
            </div>
        </div>
    );
}
